// jshint strict:false, undef:false, unused:false

/*/
	Core BS4 Javascript
	Jquery, Popper, and Bootstrap
	Updated 2019-03-18
/*/

// @codekit-prepend 'jquery/dist/jquery.min.js';
// @codekit-prepend 'popper.js/dist/umd/popper.js';

// ==============================

// @codekit-prepend 'util.js';
// @codekit-prepend 'alert.js';
// @codekit-prepend 'button.js';
// @codekit-prepend 'carousel.js';
// @codekit-prepend 'collapse.js';
// @codekit-prepend 'dropdown.js';
// @codekit-prepend 'modal.js';
// @codekit-prepend 'tooltip.js';
// @codekit-prepend 'popover.js';
// @codekit-prepend 'scrollspy.js';
// @codekit-prepend 'tab.js';
